import { render, staticRenderFns } from "./OverTablePagination.vue?vue&type=template&id=75f3a67e&scoped=true&"
import script from "./OverTablePagination.vue?vue&type=script&lang=js&"
export * from "./OverTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./OverTablePagination.vue?vue&type=style&index=0&id=75f3a67e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f3a67e",
  null
  
)

export default component.exports